<!-- 售后管理报表 -->
<template>
  <div class="container">
      <div class="search-top">
        <!-- <h1 class="titleStyle">售后管理报表</h1> -->
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="IMEI:">
              <el-input v-model='Dform.imei'  placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="名称:">
              <el-input v-model='Dform.name' placeholder=""></el-input>
            </el-form-item></el-col>
        
          <el-col :span="6">
            <el-form-item label="选择:">
              <el-select v-model="exportValue" placeholder="是否导出数据报表">
                <el-option
                  label="是"
                  value="1">
              </el-option>
                <el-option
                  label="否"
                  value="2">
              </el-option>
            </el-select>
          </el-form-item></el-col>
          <el-col :span="6">
            <el-form-item label="设备选项:">
              <el-select v-model="Dform.typeValue" placeholder="请选择设备">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          </el-col>
          <el-button type="primary" class="query-button" @click="inquiryClick">查询</el-button>
        </el-row>
      </div>
      <div class="main-content">
        <el-table
        class="table-Style"
          stripe
          :border="true"
        v-loading="loading"
          :header-cell-style="{background:'#EDF6FF',color:'#000',}"
          :data="tableData"
          style="width: 100%">
         
          <el-table-column
            prop="name"
            label="名称"
           >
          </el-table-column>
          <el-table-column
            prop="phoneNumber"
            label="设备手机号"
           >
          </el-table-column>
          <el-table-column
            label="所属单位">
            <template #default="scope">
                <span v-if="scope.row.alias != null">{{scope.row.alias}}</span>
                <span v-else>{{scope.row.userName}}</span>
              </template>
           
          </el-table-column>
          <el-table-column
            prop="imei"
            label="IMEI"
           >
          </el-table-column>
          <el-table-column
            prop="deviceUsedDays"
            label="设备使用时间（天）"
            >
          </el-table-column>
          <el-table-column
            prop="expirationTime"
            label="到期时间">
          </el-table-column>
        </el-table> 
        <div class="block">
              <!-- <span class="demonstration">直接前往</span> -->
              <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage3"
              :page-size="10"
              layout="prev, pager, next, jumper"
              :total="total">
              </el-pagination>
           </div>
      </div>
  </div>
</template>

<script>
import { 
  afterSaleManagement ,
  afterSaleManagementExport
  } from '@/assets/api/api'
export default {
  components: {

  },
  data() {
      return {
        loading:true,
        tableData: [],
        options: [
          {
            value: '',
            label: '请选择'
          },
          {
            value: '1',
            label: '使用期一年设备'
          }, {
            value: '2',
            label: '使用期两年设备'
          },{
            value: '5',
            label: '使用期3年设备'
          },
          {
            value: '4',
            label: '使用期超过3年设备'
          }
        ],  
        exportValue: '',
        Dform: {
          imei: '',
          name: '',
          typeValue: '',
        },
        pageInfo: {
          page: 1,
          pageSize: 10,
        },
        total: 0
      };
  },
  created() {
    this.afterSaleManagementClick()
  },
  mounted() {

  },
  methods: {
    inquiryClick() {
      console.log(this.exportValue);
      if ( this.exportValue == 1) {
        this.afterSaleManagementExportClick()
      } else {
        this.pageInfo.page = 1
        this.total = 0
        this.afterSaleManagementClick()
      }
    },
    afterSaleManagementClick () {
      let params = {
        imei:this.Dform.imei,
        name:this.Dform.name,
        type: this.Dform.typeValue,
        page: this.pageInfo.page,
        pageSize: this.pageInfo.pageSize,
        userId: JSON.parse(localStorage.getItem('user')).id,

      }
      afterSaleManagement(params).then((res)=> {
        this.tableData = res.data.list
        this.total = res.data.total
        console.log(this.tableData,res,'售后管理接口');
        this.loading = false
      }).catch((err)=> {
          console.log(err);
      })
    },
    afterSaleManagementExportClick () {
      let params = {
        imei:this.Dform.imei,
        name:this.Dform.name,
        type: this.Dform.typeValue,
        userId: JSON.parse(localStorage.getItem('user')).id,
      }
      afterSaleManagementExport(params).then((res)=> {
        this.handleExport(res.data,'售后管理.xls')
        console.log(this.tableData,res,'售后管理导出接口');
        this.exportValue = ''
      }).catch((err)=> {
          console.log(err);
      })
    },
    handleNodeClick(data){
        console.log(data,'树形组件');
    },
      handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val
      this.afterSaleManagementClick()
    },
    handleExport(data,name) {
      // 动态创建iframe下载文件
      let fileName = name;
      if (!data) {
          return;
      }
      let blob = new Blob([data], { type: "application/octet-stream" });
      console.log(blob);
      if ("download" in document.createElement("a")) {
          // 不是IE浏览器
          let url = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); // 下载完成移除元素
          window.URL.revokeObjectURL(url); // 释放掉blob对象
      } else {
          // IE 10+
          window.navigator.msSaveBlob(blob, fileName);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.container {
    width: 100%;
    height: 95%;
    border-radius: 15px;
    .search-top {
      height: 100px;
      background-color: #FFF;
      border-radius: 15px;
      display: flex;
      align-content: space-around;  
      align-items: center;
      .titleStyle{
        margin-left: 40px;
        font-size: 20px;
        font-weight: 700;
        width: 25%;

      }
      
      .query-button {
          padding: 16px 24px;
          // background-color:#1BC896;
          border-radius: 15px;
        }
      :deep() {
        .el-select--small .el-select__wrapper {
          height: 35px;
          border-radius: 15px
              ;
          
        }
        .el-dropdown-link {
          cursor: pointer;
          // color: #409EFF;
        }
      .el-col-6{
        max-width: 18%;
        margin-top: 20px;
        margin-left: 30px;

      }
      .el-button--small {
        margin-top: 20px;
        margin-left: 60px;
        margin-right: 20px;

      }
      .el-form-item--small .el-form-item__label{
        line-height: 32px;
        font-weight: 700;
        font-size: 16px;

      }
      .el-input--small .el-input__wrapper{
              margin-right: 15px;
              border-radius: 15px
              ;
            }
      .el-input--small .el-input__inner{
        height: 30px;
      } 
      .el-form-item {
            width: 109%;
            margin-left: 15px;
          }
      }
    }
    .main-content{
      margin-top: 15px;
      height: 85%;
      overflow: auto;
      position: relative;
      padding: 0px 15px;
      padding-top: 30px;
      margin-top: 15px;
      background-color: #FFF;
      border-radius: 8px;
      .table-Style{
        font-size: 16px;
        // border-radius: 15px;
      } 
    :deep() {
      .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
            // border: 0px;
          }
      .el-pagination{
        font-size: 16px;
        margin-left: 600px;
        margin-top: 20px;
      }
      .el-table th.el-table__cell {
        font-weight: 700;
      }
      .el-table--small .el-table__cell{
        font-size: 16px;
        padding: 8px 10px;
        text-align: center;
        color:black
      }
      .el-table td.el-table__cell div{
        // font-size: 14px;
      }
     

    }
    }
}

</style>
